import React, { useEffect } from "react";
import "../../../style.css";
import "../style.css";
import {
  commonHeaderStyle,
  commonStyle,
  displayCommaFormatter,
  displayNullFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useSelector } from "react-redux";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";

const Table = () => {
  const { issueWiseTableData } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  const subColumns = [
    {
      dataField: "subcategory",
      text: "particular",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "16%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        // width: "22%",
        display: "none",
      },
      formatter: (cell, row) => displayNullFormatter(row, "subcategory"),
    },
    {
      dataField: "document_count_pr",
      text: "doc count PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "14%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        // width: '14%'
        display: "none",
      },
      formatter: (cell, row) => displayNullFormatter(row, "document_count_pr"),
    },
    {
      dataField: "document_count_gstn",
      text: "doc count GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "14%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        // width: '14%'
        display: "none",
      },
      formatter: (cell, row) =>
        displayNullFormatter(row, "document_count_gstn"),
    },
    {
      dataField: "total_txval_pr",
      text: "tax PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "14%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        // width: '14%'
        display: "none",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "total_txval_pr"),
    },
    {
      dataField: "total_txval_gstn",
      text: "tax Gstn",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "14%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        // width: '14%'
        display: "none",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "total_txval_gstn"),
    },
    {
      dataField: "total_gst_amt_pr",
      text: "gst Amt PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "14%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        // width: '14%'
        display: "none",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "total_gst_amt_pr"),
    },
    {
      dataField: "total_gst_amt_gstn",
      text: "gst Amt GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "14%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        // width: '14%'
        display: "none",
      },
      formatter: (cell, row) =>
        displayCommaFormatter(row, "total_gst_amt_gstn"),
    },
  ];

  const Columns = [
    {
      dataField: "gstin",
      headerFormatter: () => (
        <>
          <div
            style={{
              width: "15.3%",
              // borderRight: "1px solid black",
            }}
          >
            Particulars
          </div>
          <div
            style={{
              width: "14.2%",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            PR
          </div>
          <div
            style={{
              width: "14.4%",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            GSTN
          </div>
          <div
            style={{
              width: "14.3%",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            PR
          </div>
          <div
            style={{
              width: "14.4%",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            GSTN
          </div>
          <div
            style={{
              width: "14.3%",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            PR
          </div>
          <div
            style={{
              width: "13%",
              //  borderLeft: "1px solid black",
            }}
          >
            GSTN
          </div>
        </>
      ),
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const padding = "0";
        const border = "none";
        return { fontFamily, fontSize, fontWeight, padding, border };
      },
      headerStyle: {
        display: "flex",
        paddingTop: "15px",
      },
      formatter: (cell, row, i) => {
        return (
          <>
            <div style={{ width: "100%" }}>
              <Accordion
                style={{ width: "100%" }}
                //               expanded={(row?.type === "MATCH" || row?.type === "MISMATCH")  && expanded}
                // onChange={(event, newExpanded) => {
                //   if (row?.type === "MATCH") {
                //     setExpanded(newExpanded);
                //   }
                // }}
                // className={classes.accordion}

                //  disabled={row?.particular !== "Matched" ? true : false}
              >
                <AccordionSummary
                  expandIcon={
                    row?.category === "Matched" ||
                    row?.category === "Mismatched" ? (
                      <ExpandMoreIcon />
                    ) : null
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  style={{
                    display: "block",
                    minHeight: "0px",
                    height: "28px",
                    position: "relative",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // e.preventDefault();
                  }}
                  // className={`EinvSummary-accordion ${classes.summary}`}

                  className="EinvSummary-accordion"
                  // className={classes.summary}
                >
                  <div
                    style={{ width: "100%", display: "flex" }}
                    onClick={
                      row?.category === "Matched" ||
                      row?.category === "Mismatched"
                        ? null
                        : function (e) {
                            e.stopPropagation();
                          }
                    }
                  >
                    <Typography
                      className={row.category === 'Total' ? "issue-wise-accordion-text-total" : "issue-wise-accordion-text"}
                      style={{ 
                        width: "16.7%"
                      }}
                    >
                      {displayNullFormatter(row, "category")}
                    </Typography>
                    <Typography
                      className={row.category === 'Total' ? "issue-wise-accordion-text-total" : "issue-wise-accordion-text"}
                      style={{ 
                        width: "14.6%"
                      }}
                    >
                      {displayNullFormatter(row, "document_count_pr")}
                    </Typography>
                    <Typography
                      className={row.category === 'Total' ? "issue-wise-accordion-text-total" : "issue-wise-accordion-text"}
                      style={{ 
                        width: "14.6%"
                      }}
                    >
                      {displayNullFormatter(row, "document_count_gstn")}
                    </Typography>
                    <Typography
                      className={row.category === 'Total' ? "issue-wise-accordion-text-total" : "issue-wise-accordion-text"}
                      style={{ 
                        width: "14.6%"
                      }}
                    >
                      {displayCommaFormatter(row, "total_txval_pr")}
                    </Typography>
                    <Typography
                      className={row.category === 'Total' ? "issue-wise-accordion-text-total" : "issue-wise-accordion-text"}
                      style={{ 
                        width: "14.6%"
                      }}
                    >
                      {displayCommaFormatter(row, "total_txval_gstn")}
                    </Typography>
                    <Typography
                      className={row.category === 'Total' ? "issue-wise-accordion-text-total" : "issue-wise-accordion-text"}
                      style={{ 
                        width: "14.6%"
                      }}
                    >
                      {displayCommaFormatter(row, "total_gst_amt_pr")}
                    </Typography>
                    <Typography
                      className={row.category === 'Total' ? "issue-wise-accordion-text-total" : "issue-wise-accordion-text"}
                      style={{ 
                        width: "10.3%"
                      }}
                    >
                      {displayCommaFormatter(row, "total_gst_amt_gstn")}
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <BootstrapTable
                    keyField="subcategory"
                    // data={[
                    //   { gstin: "A", particular: "Total" },
                    //   { gstin: "B", particular: "Matched" },
                    //   { gstin: "C", particular: "Mismatched" },
                    //   { gstin: "D", particular: "Probable Match" },
                    // ]}
                    data={row.subcategory ? row.subcategory : []}
                    // data={row.childData ? addKeysToData(row.childData) : []}
                    columns={subColumns}
                    rowStyle={rowStyle2}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    console.log("issueWiseTableData ::", issueWiseTableData);
  }, [issueWiseTableData]);
  return (
    <>
      {issueWiseTableData?.length > 0 ? (
        <>
          <div
            className="light-border-gstr2a2bnew-table"
            style={{ marginTop: "1em" }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
              <div
                className="issue-wise-accordion-div"
                style={{
                  width: "16.2%",
                }}
              ></div>
              <div
                className="issue-wise-accordion-div"
                style={{
                  width: "27.8%",
                }}
              >
                Document Count
              </div>
              <div
                className="issue-wise-accordion-div"
                style={{
                  width: "28%",
                }}
              >
                Taxable Value
              </div>

              <div
                className="issue-wise-accordion-div"
                style={{
                  width: "28%",
                }}
              >
                GST Amount
              </div>
            </div>
            <BootstrapTable
              keyField="type"
              // data={[
              //   { gstin: "1", particular: "Total" },
              //   { gstin: "2", particular: "Matched" },
              //   { gstin: "3", particular: "Probable Matched" },
              //   { gstin: "4", particular: "Mismatched" },
              // ]}
              data={issueWiseTableData}
              columns={Columns}
              rowStyle={rowStyle2}
            />
          </div>
        </>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default Table;
